export function FinalCTA() {
  return (
    <section id="quote" className="container final-cta" aria-labelledby="quote-heading">
      <div>
        <h2 id="quote-heading">Need a product from Iran?</h2>
        <p>Send us your requirement. We&apos;ll review available options and help you determine the next step.</p>
      </div>
      <div className="final-cta-actions">
        <a className="button button--outline" href="#sourcing-request">Request Sourcing <span aria-hidden="true">→</span></a>
        <a className="final-cta-link" href="#products">Explore Available Products</a>
      </div>
    </section>
  );
}
